module.exports = {
  IN: 'india',
  LK: 'sriLanka',
  BG: 'bangladesh'
}